import React, { useEffect, useRef, useCallback } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import gsap from 'gsap'
import Sphere from '../components/Sphere'
import Menu from '../components/Menu'
import ProjectSlider from '../components/ProjectSlider'

function Main({ projectObj }) {
  const wrapper = useRef(null)
  const line = useRef(null)
  const projectSection = useRef(null)

  let canScroll = true,
    pageIndex = 0 //started index at 0

  const snapAnimation = (x, position) => {
    const { current } = wrapper,
      children = current.children

    const childAnimation = (target, direction) => {
      gsap.fromTo(target, {
        opacity: 0.5,
        x: direction
      }, {
        opacity: 1,
        x: 0,
        duration: 1.5,
        ease: 'power2.out',
        stagger: {
          from: "start",
          each: 0.3
        }
      })
    }

    if (position === "next" && pageIndex <= 2) {
      childAnimation(children[pageIndex].children, 100)
    }

    if (position === "prev" && pageIndex >= 0) {
      childAnimation(children[pageIndex].children, -100)
    }

    gsap.to(wrapper.current, {
      scrollLeft: pageIndex === 0 ? 0 : x * pageIndex,
      duration: 0.9,
      ease: "sine.out",
      onComplete: () => {
        canScroll = true
      }
    })

    return
  }


  const snapScroll = useCallback((e) => {

    // check status dataset on swiper wrapper
    const slideWrapper = projectSection.current.children[1].children[0]
    const snapStatus = slideWrapper.dataset.onHover

    if (snapStatus === "true") return

    const y = e.deltaY,
      offset = wrapper.current.children[0].offsetWidth

    // snap previous
    if (y === -100 && canScroll) {

      if (pageIndex <= 0) return
      canScroll = false

      pageIndex--
      snapAnimation(offset, "prev")

      return

    }

    // snap next
    if (y === 100 && canScroll) {

      if (pageIndex >= 2) return
      canScroll = false

      pageIndex++
      snapAnimation(offset, "next")

      return
    }
  }, [])

  // line animation navigation
  const lineAnimation = () => {
    gsap.fromTo(line.current, { width: 0 }, { width: '6rem', duration: 1, repeat: -1, yoyo: true })
  }


  // handle clicked project slider
  const handleClickedProject = (data) => {
    projectObj(data)
  }

  useEffect(() => {
    lineAnimation()
    const slideContainer = wrapper.current

    slideContainer.addEventListener('wheel', e => {
      snapScroll(e)
    })
    return () => {
      slideContainer.removeEventListener('wheel', e => snapScroll(e))
    }
  }, [wrapper, snapScroll])

  return (
    // main container, outer container. scroll horizontally
    <AnimatePresence wait>
      <Menu />
      <motion.div
        initial={{ opacity: 0.5 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0.5 }}
        transition={{ duration: 0.8, type: "tween" }}
      >
        <section className="landing-page-container" ref={wrapper}>
          <section className="content-section section-welcome">
            {/* CONTENT WRAPPER */}
            {/* text content */}
            <aside className="welcome-text-content">
              <div className="welcome-title">
                <h1>Welcome!</h1>
              </div>
              <div className="welcome-subtitle">
                <h1
                  // for reffering to animation
                  data-title="true"
                // onMouseEnter={(e) => {
                //   textAnimation(e, "enter")
                // }}
                // onMouseLeave={e => {
                //   textAnimation(e, "leave")
                // }}
                >My name is <span>Galih Adhi Kusuma!</span>  </h1>
              </div>
              <div className="scroll-navigation">
                <span>Scroll</span>
                <div className="line">
                  <hr ref={line} />
                </div>
              </div>
            </aside>
            <div className="welcome-graphic-content">
              <Sphere />
            </div>
          </section>
          {/* ABOUT */}
          <section className="content-section section-about">
            <aside className="about-text-content">
              <div className="about-title">
                <h1>About Me!</h1>
              </div>
              <article className="about-paragraph">
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum eos, numquam laborum praesentium enim voluptatibus odit dicta, beatae accusamus et mollitia nesciunt, error quam molestiae cum hic. Cupiditate, ipsam quia, sed tempore nam error blanditiis quam eos doloribus maiores maxime!</p>
              </article>
              <Link to="/about" className="about-section-link">Read more</Link>
              {/* <div className="about-graphic-content">
                <Sphere />
              </div> */}
            </aside>
          </section>
          {/* PROJECT SHOWCASE */}
          <section className="content-section section-project-showcase" ref={projectSection}>
            <ProjectSlider childrenObj={handleClickedProject} />
          </section>
        </section>
      </motion.div>
    </AnimatePresence>
  )
}

export default Main


  // welcome title animation
  // const textAnimation = (e, state) => {
  //   let treshold = 0;

  //   if (state === "enter" && e.target.dataset.title === "true") {
  //     treshold = window.requestAnimationFrame(textAnimation)
  //     if (treshold >= 100) {
  //       gsap.fromTo(e.target, { opacity: 0, y: -25 }, {
  //         opacity: 1, y: 0, onComplete: () => {
  //           console.log('stopped')
  //           treshold = 0
  //           window.cancelAnimationFrame(treshold)
  //         }
  //       })
  //       e.target.innerHTML = "<h1>Iam the founder of <span>Noxturne</span></h1>"
  //       console.log('started')
  //     }
  //     console.log('enter')
  //     console.log(treshold)
  //     return
  //   } else if (state === "leave" && e.target.dataset.title === "true") {
  //     gsap.fromTo(e.target, { opacity: 0, y: -25 }, {
  //       opacity: 1, y: 0, onComplete: () => {
  //         treshold = 0
  //         window.cancelAnimationFrame(treshold)
  //       }
  //     })
  //     e.target.innerHTML = "<h1>My name <span>is Galih Adhi Kusuma</span></h1>"
  //     window.cancelAnimationFrame(treshold)
  //     treshold = 0
  //     console.log('leave')
  //     return
  //   }

  //   console.log(treshold)
  //   return
  // }